import './_product-ticker-carousel.scss';
import component from './product-ticker-carousel';

export default component;
